/**
 * Reissuance modal functionality
 * Handles the "Use existing CSR" button click event
 */

document.addEventListener('DOMContentLoaded', function() {
  const useExistingCsrButton = document.querySelector('.use-existing-csr');
  
  if (useExistingCsrButton) {
    useExistingCsrButton.addEventListener('click', function(event) {
      event.preventDefault();
      
      const csrTextarea = document.getElementById('csr');
      const storedCsr = csrTextarea.getAttribute('data-csr');
      
      if (storedCsr) {
        csrTextarea.value = storedCsr;
        csrTextarea.setAttribute('readonly', 'readonly');
        csrTextarea.classList.add('readonly-csr');
        
        // Auto-click Continue button after populating existing CSR
        setTimeout(function() {
          const continueButton = document.querySelector('#csr_step button.next_step');
          if (continueButton) {
            continueButton.click();
          }
        }, 300); // Brief delay to allow rendering
      }
    });
  }
});
